import React from 'react';
import './App.css';
import Homepage from './homepageFolder/homepage';

function App() {
  return (
    <div>
<Homepage />
      
    </div>
  );
}

export default App;
